import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as n } from "@mui/joy";
import { memo as r } from "react";
import { S as t } from "../../../../../../index.BRz-o-Vs.js";
const a = r(({
  syncDirection: e
}) => /* @__PURE__ */ o.jsx(n, { children: e === t.IMPORT ? null : e === t.EXPORT ? "This will export the selected dataset directly as an audience in Splicky. The dataset should have only one column, that contains OneLog OneIDs. Currently, only OneIDs are supported. Note: Please access your Splicky account to verify the created audience." : null }));
a.displayName = "SplickyInfo";
export {
  a as default
};
//# sourceMappingURL=SplickyInfo.js.map
